module.exports = __webpack_public_path__ + "img/frontal.5c573129.png";